module.exports = __webpack_public_path__ + "static/media/fifa-wwc-desktop.0fa0d051.jpg";